import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadVehiclesByIdFailed, loadVehiclesByIdSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadVehiclesById(action) {
  try {
    const url = `${BACKEND_URL}/v1/registries/vehicles/${action.payload}`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      yield put(loadVehiclesByIdSuccessful(data.data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadVehiclesByIdFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadVehiclesByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
